import { useState } from "react";

import { Box, Collapse, Container } from "@mui/material";
import { Para16Text } from "components/shared/Typography";
import parse from "html-react-parser";
import { useLocation } from "react-router-dom";

import Alert from "components/shared/Alert";
import { ANNOUNCEMENT } from "helpers/apis";
import useAxios from "helpers/axios";
import { IAnnouncement } from "types/announcement";

export const Announcement = () => {
  const { pathname } = useLocation();
  const [announcement, setAnnouncement] = useState<IAnnouncement | null>(null);
  useAxios({
    config: { url: ANNOUNCEMENT },
    successCallback: ({ response }: any) => {
      if (Array.isArray(response) && response.length) {
        setAnnouncement(response[0]);
      }
    },
  });

  return (
    <Collapse in={!!announcement && pathname === "/"}>
      <Box bgcolor="grey.500" py={3} width={1} className="announcement">
        <Container>
          <Alert severity="info" noDismiss icon={false}>
            <Para16Text>{parse(announcement?.content || "")}</Para16Text>
          </Alert>
        </Container>
      </Box>
    </Collapse>
  );
};
